import { FunctionalComponent } from 'preact'

// Small presentational atoms for the contact-detail surface (ORB-383). Pure helpers + icon paths live
// in ./contactFormat so this stays a components-only module (fast-refresh requirement).

interface ConsentChipProps { state: string; big?: boolean }

export const ConsentChip: FunctionalComponent<ConsentChipProps> = ({ state, big }) => {
  const cfg: Record<string, { label: string; cls: string; path: string }> = {
    Subscribed: { label: 'Subscribed', cls: 'text-primary-700 dark:text-primary-400', path: 'M20 6 9 17l-5-5' },
    Unsubscribed: { label: 'Unsubscribed', cls: 'text-amber-700 dark:text-amber-400', path: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M5.6 5.6 18.4 18.4' },
    HardBounced: { label: 'Hard bounced', cls: 'text-red-700 dark:text-red-400', path: 'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0ZM12 9v4M12 17h.01' },
  }
  const c = cfg[state] || cfg.Subscribed
  const sz = big ? 14 : 12
  return (
    <span class={`inline-flex items-center gap-1 font-medium ${c.cls}`}>
      <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d={c.path} /></svg>
      {c.label}
    </span>
  )
}

interface ScopeBadgeProps { scope: string }

export const ScopeBadge: FunctionalComponent<ScopeBadgeProps> = ({ scope }) => {
  const label = scope === 'Web' ? 'Web slice' : scope === 'Company' ? 'Company-wide' : 'Campaign'
  const title = scope === 'Web'
    ? 'You are viewing only this web’s slice of this contact'
    : scope === 'Company'
      ? 'Everything this customer has touched about this person, across campaigns and workspaces'
      : 'This contact unified across the campaign'
  return (
    <span class="inline-flex items-center gap-1 rounded-full bg-slate-200/70 dark:bg-slate-800 px-2 py-0.5 text-xs font-medium text-slate-600 dark:text-slate-300" title={title}>
      {label}
    </span>
  )
}

interface IconProps { path: string; size?: number; strokeWidth?: number; class?: string }

// Renders one or more SVG paths (split on '|') in a 24x24 viewBox.
export const Icon: FunctionalComponent<IconProps> = ({ path, size = 14, strokeWidth = 2, class: className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={strokeWidth} class={className} aria-hidden="true">
    {path.split('|').map((d, i) => <path key={i} d={d} />)}
  </svg>
)
